import {
  IconClipboardList,
  IconHistory,
  IconKey,
  IconScale,
  IconShieldLock,
  IconUsers,
  IconUsersGroup,
  IconArrowsExchange,
} from '@tabler/icons-react';
import { defineModule } from '../types';
import { indexRoute, lazyRoute, routeGroup } from '../routing';
import { P } from './perms';

const roles = () => import('./pages/RolesPages');
const reviews = () => import('./pages/AccessReviewsPages');
const audit = () => import('./pages/AuditPages');

/**
 * IAM — users, roles & scoped permissions, delegations, access reviews, audit (FR-IAM-01..16).
 */
export default defineModule({
  code: 'iam',
  nameAr: 'الهوية والصلاحيات',
  nameEn: 'Identity & access',
  icon: IconShieldLock,
  order: 20,
  menu: [
    { key: 'iam.users', labelKey: 'iam:nav.users', path: '/iam/users', icon: IconUsers, permission: P.user.read },
    { key: 'iam.roles', labelKey: 'iam:nav.roles', path: '/iam/roles', icon: IconUsersGroup, permission: P.role.read },
    { key: 'iam.permissions', labelKey: 'iam:nav.permissions', path: '/iam/permissions', icon: IconKey, permission: P.role.read },
    { key: 'iam.delegations', labelKey: 'iam:nav.delegations', path: '/iam/delegations', icon: IconArrowsExchange, permission: P.delegation },
    { key: 'iam.accessReviews', labelKey: 'iam:nav.accessReviews', path: '/iam/access-reviews', icon: IconClipboardList, permission: P.accessReview },
    { key: 'iam.audit', labelKey: 'iam:nav.auditLog', path: '/iam/audit-logs', icon: IconHistory, permission: P.auditLog },
    { key: 'iam.sod', labelKey: 'iam:nav.sodReport', path: '/iam/sod-report', icon: IconScale, permission: P.sodReport },
  ],
  routes: {
    admin: [
      routeGroup('iam/users', 'iam:nav.users', [
        indexRoute(() => import('./pages/UsersPage'), P.user.read),
        lazyRoute(':id', () => import('./pages/UserDetailPage'), { permission: P.user.read }),
      ]),
      routeGroup('iam/roles', 'iam:nav.roles', [
        indexRoute(() => roles().then((m) => ({ default: m.RolesPage })), P.role.read),
        lazyRoute(':id', () => roles().then((m) => ({ default: m.RoleDetailPage })), { permission: P.role.read }),
      ]),
      lazyRoute('iam/permissions', () => roles().then((m) => ({ default: m.PermissionsPage })), { permission: P.role.read, crumb: 'iam:nav.permissions' }),
      lazyRoute('iam/delegations', () => import('./pages/DelegationsPage'), { permission: P.delegation, crumb: 'iam:nav.delegations' }),
      routeGroup('iam/access-reviews', 'iam:nav.accessReviews', [
        indexRoute(() => reviews().then((m) => ({ default: m.AccessReviewsPage })), P.accessReview),
        lazyRoute(':id', () => reviews().then((m) => ({ default: m.AccessReviewDetailPage })), { permission: P.accessReview }),
      ]),
      lazyRoute('iam/audit-logs', () => audit().then((m) => ({ default: m.AuditLogPage })), { permission: P.auditLog, crumb: 'iam:nav.auditLog' }),
      lazyRoute('iam/sod-report', () => audit().then((m) => ({ default: m.SodReportPage })), { permission: P.sodReport, crumb: 'iam:nav.sodReport' }),
    ],
  },
});

